/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const HeadphoneLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 4a8 8 0 0 0-8 8h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a10 10 0 1 1 20 0v7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2h3a8 8 0 0 0-8-8M4 14v5h3v-5zm13 0v5h3v-5z" />
  </Icon>
);
